import AppStoresQRCodeIcon from 'assets/icons/app_stores_qr_code.svg';
import AppleAppStoreIcon from 'assets/icons/apple_app_store.svg';
import GooglePlayStoreIcon from 'assets/icons/google_play_store.svg';
import React from 'react';
import { APPSTORE_DOWNLOAD_URL, PLAYSTORE_DOWNLOAD_URL } from 'util/constants';

import { Box, Grid, Stack, Typography } from '@mui/material';

export const TutorPlanOrderResumeDownloadApp: React.FC = () => {
  return (
    <Grid item container xs={12} lg={12} spacing={2}>
      <Grid item xs={12} md={5} spacing={2}>
        <Stack spacing={2}>
          <Typography color="#000000" fontSize={24} fontWeight={400}>
            BAIXAR APLICATIVO
          </Typography>

          <Typography color="#7A8388" fontSize={14} fontWeight={400}>
            Você pode baixar o aplicativo Vet4all gratuitamente nas lojas de
            aplicativo lendo o QR code com seu celular e aproveitar tudo o que
            temos para oferecer a você e ao seu pet.
          </Typography>
        </Stack>
      </Grid>

      <Grid item container xs={12} md={7} spacing={2} justifyContent="flex-end">
        <Grid item container xs={12} md={4} justifyContent="center">
          <Box
            component="img"
            alt="Imagem QR Code"
            src={AppStoresQRCodeIcon}
            width={170}
            height={170}
          />
        </Grid>

        <Grid item container xs={12} md={6} justifyContent="flex-end">
          <Stack
            spacing={2}
            justifyContent="center"
            alignItems="center"
            display="flex"
          >
            <a href={PLAYSTORE_DOWNLOAD_URL} target="blank">
              <Box
                component="img"
                alt="Ícone Google Play Stores"
                src={GooglePlayStoreIcon}
                width={150}
                height={43}
              />
            </a>

            <a href={APPSTORE_DOWNLOAD_URL} target="blank">
              <Box
                component="img"
                alt="Ícone App Store"
                src={AppleAppStoreIcon}
                width={150}
                height={43}
              />
            </a>
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  );
};
